import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockWastageReportModel} from "./stock-wastage-report.model";

@Component({
    selector: "wbo-stock-wastage-report",
    templateUrl: "./stock-wastage-report.component.html",
    providers: [provideReportModel(StockWastageReportModel)]
})
export class StockWastageReportComponent extends AbstractReportPage {

    constructor(public model: StockWastageReportModel) {
        super();
    }
}
